export const isDirty = (formRef) => {
  const fd = new FormData(formRef);
  return Array.from(fd.values()).some((x) => x);
};
